import { render } from "./IconSetting.vue?vue&type=template&id=5d019a9d"
import script from "./IconSetting.vue?vue&type=script&lang=js"
export * from "./IconSetting.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__